module.exports = __webpack_public_path__ + "img/detallecurso1.f1e751ac.png";